import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import { ReactElement, useState } from "react";

import CreateCollectionDialog from "../../components/dialogs/collection/create-collection";
import LayoutSwitcher from "../../components/layout-switcher/layout-switcher";
import useText from "../../hooks/use-text";
import Navigation from "../../layout/navigation";
import { LocalizedStrings, SupportedLanguages } from "../../utils/lang";

import CollectionsSearchbar from "./collections-searchbar";

export default function CollectionsNavigation(): ReactElement {
  const { strings } = useText(local);
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <Navigation classes="!pl-[345px]">
      <CollectionsSearchbar />
      <LayoutSwitcher />
      <Button
        className="!border-none !bg-white shadow rounded-[15px] px-[20px] text-[15px] font-bold h-full w-[260px] upppercase"
        startIcon={<AddIcon />}
        onClick={() => setOpenDialog(true)}
      >
        {strings.newCollection}
      </Button>
      <CreateCollectionDialog
        open={openDialog}
        redirectAfterCreation
        onClose={() => setOpenDialog(false)}
      />
    </Navigation>
  );
}

type LocalSchema = {
  search: {
    label: string;
  };
  newCollection: string;
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    search: {
      label: "Search collections",
    },
    newCollection: "New Collection",
  },
};
